import React from 'react';
import { motion } from 'framer-motion';
const problems = [{
  num: '01',
  title: 'Responder las mismas preguntas',
  desc: 'Tu equipo repite las mismas respuestas todo el día en lugar de cerrar oportunidades.',
  solution: 'ORIGEN responde por WhatsApp con IA, al instante.'
}, {
  num: '02',
  title: 'Perseguir leads que dejaron de responder',
  desc: 'Los clientes potenciales se enfrían mientras nadie hace seguimiento a tiempo.',
  solution: 'ORIGEN califica y hace seguimiento automático.'
}, {
  num: '03',
  title: 'Coordinar citas y seguimientos manualmente',
  desc: 'Agendar, confirmar y recordar citas a mano consume horas cada semana.',
  solution: 'ORIGEN agenda, confirma y recuerda por ti.'
}];
export function Problem() {
  return <section className="bg-arena py-[72px] md:py-[120px]" data-id="element-303" data-mp="22yberzkhry7p">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-304" data-mp="22wqk89y6gf9u">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-14 md:mb-20 max-w-[600px]" data-id="element-305" data-mp="27ql8zrsn3kfs">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-6" data-id="element-306" data-mp="1cpkhhi217v0k">
            EL PROBLEMA
          </span>
          <h2 className="font-display text-[32px] md:text-[48px] font-bold text-carbon leading-[1.1]" data-id="element-307" data-mp="1mh6wlphhqe8l">
            Tu equipo no debería hacer esto manualmente.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6" data-id="element-308" data-mp="1wfe31ee5ldwc">
          {problems.map((item, idx) => <motion.div key={item.num} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: idx * 0.1
        }} className="flex flex-col" data-id="element-309" data-mp="61x1py739wix" data-mpi={idx}>
              <span className="block font-body text-[13px] font-semibold text-carbon/25 mb-4" data-id="element-310" data-mp="2g4fdrgap6ep6">
                {item.num}
              </span>
              <h3 className="font-display text-[20px] font-semibold text-carbon mb-2" data-id="element-311" data-mp="2p3isy96qu9ye">
                {item.title}
              </h3>
              <p className="font-body text-[15px] text-carbon/60 leading-relaxed mb-4" data-id="element-312" data-mp="2tvtu1fd801sj">
                {item.desc}
              </p>
              <div className="h-px w-full bg-carbon/10 mb-4" data-id="element-313" data-mp="2yvop7v413dje" />
              <p className="font-body text-[14px] font-medium text-verde" data-id="element-314" data-mp="33tzv5ur7d3wc">
                → {item.solution}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}